import React, { useState } from "react";
const Redeem = () => {
  const options = [
    { value: 'ragnar1', label: 'Ragnar Battle Pass', imgSrc: '/images/recievedLogo.svg' },
    { value: 'ragnar2', label: 'Ragnar Battle Pass Two', imgSrc: '/images/eth.png' },
    { value: 'ragnar3', label: 'Ragnar Battle Pass Three', imgSrc: '/images/metamask.svg' },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
<div className="text-white bg-[#0D1524] section-wrapper font-primary mt-section mt-[100px] rounded-[10px]">
  <h1 className="text-white text-2xl pt-[50px] pl-5 md:pl-10">Redeem Your Eden Battle Pass For ETH</h1>
  <div className="p-10 flex items-center justify-center">
    <div className="bg-[#040E20] p-8 rounded-lg shadow-lg w-full max-w-3xl">
          <label className="block text-gray-400 mb-2">Select Eden Battle Pass</label>
          <div className=" grid grid-cols-12 gap-6">

      {/* Left Section */}
      <div className="md:col-span-7 col-span-12">
        <div className="mb-4">
        <div className="relative w-100">
      <div
        className="w-full p-3 bg-[#141d2d] text-white rounded-lg flex items-center justify-between cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
        style={{ backgroundPosition: 'calc(100% - 10px) center', paddingRight: '30px' }}
      >
        <div className="flex items-center space-x-2">
          <img src={selectedOption.imgSrc} alt={selectedOption.label} className="w-8 h-8 rounded-full" />
          <span>{selectedOption.label}</span>
        </div>
        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </div>
      {isOpen && (
        <div className="absolute z-10 bg-[#141d2d] text-white border border-gray-300 rounded-lg w-full mt-1">
          {options.map(option => (
            <div
              key={option.value}
              className="flex items-center space-x-2 p-3 hover:bg-gray-700 cursor-pointer"
              onClick={() => handleChange(option)}
            >
              <img src={option.imgSrc} alt={option.label} className="w-8 h-8 rounded-full" />
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
        </div>
        <div className="mb-4 flex justify-end items-center gap-4">
          <div className=" ">
            <span className="block text-[15px] font-medium text-gray-400 mb-2">Number of Eden Pass</span>
          </div>
          <div className="">
            <input
              type="number"
              className="w-full p-3 bg-[#141d2d] text-white rounded-lg"
              placeholder="Number of Eden Battle Pass"
            />
          </div>
        </div>
        <div className="mb-4 flex justify-end items-center gap-4">
          <div className="flex justify-end items-center">
            <span className="text-gray-400 mb-2">Redeemable No</span>
          </div>
          <div>
            <input
              type="text"
              className="w-full p-3 bg-[#141d2d] text-white rounded-lg"
              placeholder="Enter quantity..."
            />
          </div>
        </div>
        <button className="w-full p-3 bg-gradient-to-r from-blue-400 to-blue-500 text-white rounded-[50px]">
          Redeem now
        </button>
      </div>
      
      {/* Right Section */}
      <div className="md:col-span-5 col-span-12 flex justify-center item-center w-full">
        <div className="bg-[#141d2d] w-full p-2 rounded-lg flex flex-col items-start justify-bwtween">
            <div className="col-12 mb-auto flex flex-row mt-2">
            <img
                            src="/images/recievedLogo.svg"
                            alt="image"
                            className="w-8 h-8"
                          />
          <h2 className="text-white text-xl mb-2">You Receive</h2>
            </div>
          <div className="text-white text-6xl mb-2 self-start">25</div>
          <div className="text-gray-400 mt-auto mb-2">out of <span className="text-white">35060</span></div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default Redeem;
